module.exports = __webpack_public_path__ + "35b478a95ecaa73a446aef16db89a79b.woff2";